import type { FC } from 'react';

import RecipeButtonWithFlyIn from './RecipeButtonWithFlyIn';
import { useRecipeModal } from './RecipeItemPageModalTrigger.hooks';

interface RecipeModalTriggerProps {
    recipeId: string;
    recipeName: string;
    recipeType: 'recipe' | 'foodbox';
    portions: number;
    onBuyClick?: (e: React.SyntheticEvent) => void;
    onRemoveClick?: (e: React.SyntheticEvent) => void;
    buyText?: string;
    removeText?: string;
    buttonSize: 'default' | 'large';
    buttonFullWidth: boolean;
    analyticsListName: string;
}

const RecipeItemPageModalTrigger: FC<React.PropsWithChildren<RecipeModalTriggerProps>> = ({
    recipeId,
    recipeName,
    recipeType,
    portions,
    onBuyClick,
    onRemoveClick,
    buyText,
    removeText,
    buttonSize,
    analyticsListName,
    buttonFullWidth,
}) => {
    const { close, isOpen, tryOpen } = useRecipeModal(recipeId, recipeName);

    const onRecipeBuyClick = (e: React.SyntheticEvent) => {
        tryOpen();

        onBuyClick?.(e);
    };

    return (
        <RecipeButtonWithFlyIn
            viewType="cart"
            allowRecipePageRedirect
            recipeId={recipeId}
            recipeName={recipeName}
            recipeType={recipeType}
            defaultPortions={portions}
            analyticsListName={analyticsListName}
            isOpen={isOpen}
            close={close}
            onBuyClick={onRecipeBuyClick}
            onRemoveClick={onRemoveClick}
            buyText={buyText}
            removeText={removeText}
            buttonSize={buttonSize}
            buttonFullWidth={buttonFullWidth}
        />
    );
};

export default RecipeItemPageModalTrigger;
